import React from "react";
import {useTranslation} from "react-i18next";
import "./NFDocumentFooter.css";

interface IProps {
    children?: React.ReactNode;
}

export const NFDocumentFooter = ({children}: IProps) => {
    const {t} = useTranslation();
    return (
        <>
            <div className={"nf-document-footer-body"}>
                <b>{t("Document totals")}</b>
                <div className={"mt-2"}>
                    {children}
                </div>
            </div>
        </>
    )
}